export default __webpack_public_path__ + "static/media/founder2.ba7a9fb6.jpeg";